<template>
  <v-flex xs12>
    <GmapMap
      ref="mapSettings"
      :center="{lat:(getBranch.latitude != null) ? getBranch.latitude : 19.702559, 
					lng:(getBranch.longitude != null) ? getBranch.longitude : -101.192341 }"
      :zoom="(getBranch.zoom != null) ? getBranch.zoom : 20"
      style="height: 500px; margin-top:3px;"
      :options="mapConfig"
    >
      <v-toolbar dense color="transparent" floating id="toolbar" class="titleSearch elevation-0">
        <v-text-field
          class="mx-3 mt-4"
          v-model="search"
          @keyup.enter="searchName"
          label="Buscar"
          prepend-inner-icon="search"
          clearable
          solo
        ></v-text-field>
      </v-toolbar>
    </GmapMap>
    <info v-model="flags.info" text="No se encontraron ubicaciones"></info>
  </v-flex>
</template>

<script>
import { mapGetters } from "vuex";
import { mapSettings } from "@/Catalogs/mapSettings";
import { gmapApi } from "vue2-google-maps";
import info from "../../Dialogs/Info";
export default {
  components: {
    info
  },
  data: () => ({
    map: {},
    search: "",
    markers: [],
    flags: {
      loaded: false,
      info: false
    }
  }),
  mounted() {
    var v = this;
    this.$refs.mapSettings.$mapPromise.then(map => {
      v.map = map;
      map.setZoom(v.getBranch.zoom != null ? v.getBranch.zoom : 17);
      var input = document.getElementById("toolbar");
      var searchBox = new google.maps.places.SearchBox(input);
      map.controls[google.maps.ControlPosition.TOP_CENTER].push(input);

      var position = new google.maps.LatLng(
        v.getBranch.latitude,
        v.getBranch.longitude
      );

      var marker = new google.maps.Marker({
        map: v.map,
        icon: v.markerBranchIcon,
        position: position
      });
      v.markers.push(marker);
      var infowindow = new google.maps.InfoWindow();
      v.map.setCenter(position);
      v.map.setZoom(18);
      infowindow.setContent(
        "<b>" +
          v.getBranch.name +
          "</b><br>" +
          v.getBranch.address +
          "<br>" +
          "<p>Si no encuentras la institución, puedes utilizar la barra de búsqueda para encontrar la dirección</p>"
      );
      v.$emit("input", v.getBranch.address);

      infowindow.open(v.map, marker);
    });
  },
  methods: {
    searchName() {
      if (this.markers.length > 0) {
        this.markers[0].setMap(null);
        this.markers = [];
      }
      var v = this;
      var request = {
        query: this.search,
        fields: ["name", "geometry", "formatted_address"]
      };
      var service = new google.maps.places.PlacesService(this.map);

      service.findPlaceFromQuery(request, function(results, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          var position = new google.maps.LatLng(
            results[0].geometry.location.lat(),
            results[0].geometry.location.lng()
          );

          var marker = new google.maps.Marker({
            map: v.map,
            icon: v.markerBranchIcon,
            position: position
          });
          v.markers.push(marker);
          var infowindow = new google.maps.InfoWindow();
          v.map.setCenter(position);
          v.map.setZoom(18);
          infowindow.setContent(
            "<b>" +
              results[0].name +
              "</b><br>" +
              results[0].formatted_address +
              "<br>" +
              "<p>Si no encuentras la institución, puedes utilizar la barra de búsqueda para encontrar la dirección</p>"
          );
          v.$emit("input", results[0].formatted_address);

          infowindow.open(v.map, marker);
        } else {
          v.flags.info = true;
          v.$emit("input", "");
        }
      });
    }
  },
  computed: {
    google: gmapApi,
    mapConfig() {
      return {
        ...mapSettings
      };
    },
    markerBranchIcon() {
      return {
        url: require("@/assets/mapIcons/if_map-marker_3688470.png"),
        scaledSize: new google.maps.Size(48, 48),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(24, 48),
        labelOrigin: new google.maps.Point(24, 0)
      };
    },
    ...mapGetters(["getBranch"])
  }
};
</script>

<style>
.titleSearch .v-input .v-input__slot {
  border-radius: 33px !important;
}

.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
  display: flex !important;
  align-items: center !important;
  min-height: auto !important;
}
</style>
